import { Site, SLD, DeployEnv } from '@patsnap-utils/biz';

const EU_HELP_LINK = 'https://patsnap.zendesk.com/auth/v2/login/continue_with_sso_tracking?auth_origin=4665402834717%2Cfalse%2Ctrue&brand_id=4665402834717&locale=en-us&remote_auth_id=18719448547741&return_to=https%3A%2F%2Fpatsnap.zendesk.com%2Fhc%2Fen-us&role=end_user&theme=hc'

export const generateHelpLink = (region: DeployEnv) => {
    if (region.toLowerCase() === DeployEnv.US.toLowerCase()) {
        return new Site({ sld: SLD.HELP, pathname: 'hc/en-us/signin' }).href;
    } else {
        return EU_HELP_LINK;
    }
}
